import React from 'react'
import SimulateurDevis from './components/SimulateurDevis'

export default function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-100">
      <SimulateurDevis />
    </div>
  )
}
